const isProduction = window.location.hostname !== "localhost";

const API_URL = isProduction
  ? "https://sipsliquor.shopat1stop.com/api"
  : "http://localhost:5000/api";

export const IMAGE_URL = isProduction
  ? "https://sipsliquor.shopat1stop.com/uploads/"
  : "http://localhost:5000/uploads/";

export default API_URL;